// Shared helpers for order status row styling and sorting.
// Used by Mitarbeiter, Kunde and Customer Show views.

import { ORDER_CONSTANTS } from '@/services/orderService'

// Kanban-board columns, derived from the canonical STATUS_OPTIONS so the board
// view stays in sync with the list/detail views. Each column exposes the
// shape OrderBoardView expects: { status, label, color }.
export const BOARD_COLUMNS = ORDER_CONSTANTS.STATUS_OPTIONS.map(opt => ({
  status: opt.value,
  label: opt.text,
  color: opt.color,
}))

const STATUS_CLASS = {
  inquiry: 'row-status-inquiry',
  ordered: 'row-status-ordered',
  order_received: 'row-status-ordered',
  prepress: 'row-status-prepress',
  plates: 'row-status-plates',
  printing: 'row-status-printing',
  processing: 'row-status-processing',
  processing_complete: 'row-status-processing',
  shipping: 'row-status-shipping',
  delivered: 'row-status-delivered',
  invoiced: 'row-status-invoiced',
  archived: 'row-status-archived',
}

export function getOrderRowClass(row) {
  if (!row) return ''
  const key = row.status || row.order_status
  return STATUS_CLASS[key] || ''
}

export function sortOrders(orders, field, direction = 'asc') {
  if (!Array.isArray(orders) || !field) return orders || []
  const dir = direction === 'desc' ? -1 : 1
  return [...orders].sort((a, b) => {
    const av = a?.[field]
    const bv = b?.[field]
    if (av == null && bv == null) return 0
    if (av == null) return 1
    if (bv == null) return -1
    if (av < bv) return -1 * dir
    if (av > bv) return 1 * dir
    return 0
  })
}
